module.exports = __webpack_public_path__ + "static/media/logo_docsign.82053f07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_docsign.png
// module id = 1299
// module chunks = 17